import { addScrollerBottomMargin } from "../utils/create-scroller";
import { gsap, ScrollTrigger, ScrollToPlugin } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const plansScroll = () => {

  const section = document.querySelector('section.prices_plans');
  if (!section) return;

  const runScroll = () => {
    const scroller = section.querySelector('[data-scroller]');
    const items = [...scroller.querySelectorAll('[data-scroller-item]')];
    const targetScroller = section.querySelector('[data-scroller-target]');
    const targetScrollerItems = [...targetScroller.querySelectorAll('.prices_icon')];

    const changeContent = (idx) => {
      targetScrollerItems.forEach((el, i) => el.classList.toggle('active', i === idx));
      gsap.to(targetScroller, { scrollTo: targetScrollerItems[idx], ease: "none" });
    }

    addScrollerBottomMargin(scroller, targetScrollerItems);

    items.forEach((item, idx) => {

      ScrollTrigger.create({
        scroller: scroller,
        trigger: item,
        // markers: true,
        start: "top center",
        end: () => `+=${item.clientHeight}px`,
        // end: "bottom bottom",
        onToggle(e) {
          e.isActive && changeContent(idx);
        }
      });

      gsap.timeline({
        scrollTrigger: {
          // markers: true,
          scroller: scroller,
          trigger: item,
          scrub: true,
          start: "top 10%",
        }
      })
        .to(item, { scale: 0.5, yPercent: 75, ease: "none" }, "move")
    });
  }

  gsap.matchMedia().add(
    "(min-width: 1025px)", () => {
      runScroll();
    }
  );
}

export { plansScroll }